import { useHistory } from 'react-router-dom';

export const useSetPaginationParamsV1 = () => {
  const history = useHistory();
  return (params: string) => history.replace({ search: params });
};
